module.exports = __webpack_public_path__ + "img/login_logo.95f26a1f.png";